export const RoutingPathsTree = {
    NotFounded: {
        path: '404',
        route: '/404',
    },
    NoAccess: { path: 'no-access', route: '/no-access' },
    Home: {
        path: 'home',
        route: '/home',
        children: {
            BuildHomeDashboard: {
                path: 'build-home-dashboard',
                route: '/home/build-home-dashboard',
            },
        },
    },
    Dashboards: {
        path: 'dashboards',
        route: '/dashboards',
        children: {
            Prospect: {
                path: 'prospect',
                route: '/dashboards/prospect',
                children: {
                    Edit: {
                        path: 'teammate/edit/:id',
                        route: '/dashboards/prospect/teammate/edit',
                    },
                },
            },
            Onboarding: {
                path: 'onboarding',
                route: '/dashboards/onboarding',
                children: {
                    Edit: {
                        path: 'teammate/edit/:id',
                        route: '/dashboards/onboarding/teammate/edit',
                    },
                },
            },
            Active: {
                path: 'active',
                route: '/dashboards/active',
                children: {
                    Edit: {
                        path: 'teammate/edit/:id',
                        route: '/dashboards/active/teammate/edit',
                    },
                },
            },
            Offboarding: {
                path: 'offboarding',
                route: '/dashboards/offboarding',
                children: {
                    Edit: {
                        path: 'teammate/edit/:id',
                        route: '/dashboards/offboarding/teammate/edit',
                    },
                },
            },
            Branch: {
                path: 'branch',
                route: '/dashboards/branch',
                children: {
                    Add: {
                        path: 'add',
                        route: '/dashboards/branch/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/dashboards/branch/edit',
                    },
                },
            },
            Licensing: {
                path: 'licensing',
                route: '/dashboards/licensing',
                children: {
                    Corporate: {
                        path: 'licensing/corporate-type',
                        route: '/dashboards/licensing/corporate-type',
                        Edit: {
                            path: 'edit/:id',
                            route: '/dashboards/licensing/corporate-type/edit',
                        },
                    },
                    Branch: {
                        path: 'licensing/branch-type',
                        route: '/dashboards/licensing/branch-type',
                        Edit: {
                            path: 'edit/:id',
                            route: '/dashboards/licensing/branch-type/edit',
                        },
                    },
                    Teammate: {
                        path: 'licensing/teammate-type',
                        route: '/dashboards/licensing/teammate-type',
                        Edit: {
                            path: 'edit/:id',
                            route: '/dashboards/licensing/teammate-type/edit',
                        },
                    },
                },
            },
            Favorites: {
                path: 'favorites/:id',
                route: '/dashboards/favorites',
            },
        },
    },
    Templates: {
        path: 'templates',
        route: '/templates',
        children: {
            BusinessTitles: {
                path: 'business-titles',
                route: '/templates/business-titles',
                children: {
                    Add: {
                        path: 'add',
                        route: '/templates/business-titles/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/templates/business-titles/edit',
                    },
                },
            },
            BusinessPositions: {
                path: 'business-positions',
                route: '/templates/business-positions',
                children: {
                    Add: {
                        path: 'add',
                        route: '/templates/business-positions/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/templates/business-positions/edit',
                    },
                },
            },
            Compensation: {
                path: 'compensation',
                route: '/templates/compensation',
                children: {
                    Add: {
                        path: 'add',
                        route: '/templates/compensation/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/templates/compensation/edit',
                    },
                },
            },
            Emails: {
                path: 'emails',
                route: '/templates/emails',
                children: {
                    Add: {
                        path: 'add',
                        route: '/templates/emails/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/templates/emails/edit',
                    },
                },
            },
            Tags: {
                path: 'tags',
                route: '/templates/tags',
            },
            Tasks: {
                path: 'tasks',
                route: '/templates/tasks',
                children: {
                    Add: {
                        path: 'add',
                        route: '/templates/tasks/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/templates/tasks/edit',
                    },
                },
            },
        },
    },
    Tasks: {
        path: 'tasks',
        route: '/tasks',
        children: {
            UnassignedTasks: {
                path: 'unassigned',
                route: '/tasks/unassigned',
                children: {
                    Edit: {
                        path: 'task/edit/:id',
                        route: '/tasks/unassigned/task/edit',
                    },
                },
            },
            MyTasks: {
                path: 'my',
                route: '/tasks/my',
                children: {
                    Edit: {
                        path: 'task/edit/:id',
                        route: '/tasks/my/task/edit',
                    },
                },
            },
            AllTasks: {
                path: 'all',
                route: '/tasks/all',
                children: {
                    Edit: {
                        path: 'task/edit/:id',
                        route: '/tasks/all/task/edit',
                    },
                },
            },
        },
    },
    Reports: { path: 'reports', route: '/reports', children: {} },
    Settings: {
        path: 'settings',
        route: '/settings',
        children: {
            Users: {
                path: 'users',
                route: '/settings/users',
                children: {
                    Add: {
                        path: 'add',
                        route: '/settings/users/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/settings/users/edit',
                    },
                },
            },
            History: {
                path: 'history',
                route: '/settings/history',
            },
            Fields: {
                path: 'fields',
                route: '/settings/fields',
                children: {
                    Add: {
                        path: 'add',
                        route: '/settings/fields/add',
                    },
                    Edit: {
                        path: 'edit/:id',
                        route: '/settings/fields/edit',
                    },
                },
            },
        },
    },
    BulkExport: {
        path: 'export',
        route: '/export',
    },
    BulkImport: {
        path: 'import',
        route: '/import',
    },
    BranchImport: {
        path: 'branch-import',
        route: '/branch-import',
    },
    Calendar: {
        path: 'calendar',
        route: '/calendar',
    },
    Events: {
        path: 'events',
        route: '/events',
        children: {
            Edit: {
                path: 'edit/:id',
                route: '/events/edit',
            },
        },
    },
    SearchResults: {
        path: 'search-results',
        route: '/search-results',
    },
    UserSettings: {
        path: 'user-settings',
        route: '/user-settings',
    },
};
